import List from "../../containers/Blogs/List";
import Entry from "../../containers/Blogs";

const blogRoutes = [
  {
    path: "/blogs",
    exact: true,
    auth: true,
    component: List
  },
  {
    path: "/blogs/:type",
    exact: true,
    auth: true,
    component: Entry
  },
  {
    path: "/blogs/:type/:id",
    exact: true,
    auth: true,
    component: Entry
  }
];

export default blogRoutes;



// WEBPACK FOOTER //
// ./src/routes/modules/blog.jsx